
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { shareReplay, switchMap } from 'rxjs/operators';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { BuildingModel, RequestJsonPayload } from 'src/app/models/building.model';
import { environment } from 'src/environments/environment';
import { JsonDocCreateResponse } from 'src/app/shared/services/uploaddocument/json-doc-create-response';
import { PartyModel } from 'src/app/models/party.model';
import { Document } from 'src/app/models/document.model';
import { CaseTypeService } from '../../services/case-types.service';
import { ApartmentOccupantsModel, JobDetailsModel, SubRehababilitationModel } from '../models/sub-rehab.model';
import { BuildingHutsIdResponseModel } from 'src/app/shared/building-search/models/buildingHutsId.response.model';
import { OwnerInformationModel } from '../../models/owner-information.model';


@Injectable({
    providedIn: 'root'
})
export class SubRehabilitationService {
    baseurl = environment.baseUrlJsonpayloads;
    documentId: any;
    subRehabilitationModelSubject: BehaviorSubject<SubRehababilitationModel> = new BehaviorSubject(new SubRehababilitationModel());
    transactionSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    transactionId$: Observable<string> = this.transactionSubject.asObservable();
    baseUrlCodeTable = environment.baseUrlCodeTable;
    baseUrlJSON = environment.baseUrlJsonpayloads;
    baseUrlJsonPayloads = environment.baseUrlJsonpayloads;
    baseIncidentsAPI = environment.baseIncidentsAPI;
    transactionId: string;

    constructor(
        private http: HttpClient,
        private caseTypeService: CaseTypeService) {
        this.caseTypeService.transactionId$.subscribe(transactionId => {
            this.transactionId = transactionId;
        });
    }
    public readonly fetchJsonData$: Observable<any> = this.transactionId$.pipe(
        switchMap((transactionId: string) =>
            transactionId && transactionId !== undefined ?
                this.http.get<any>(`${this.baseUrlJsonPayloads}/jsonpayloads/${transactionId}`) :
                of(null as any)
        ),
        shareReplay(1)
    );

    groundExemptions$: Observable<CodeDescriptionModel> =
        this.http.get<CodeDescriptionModel>(`${this.baseUrlCodeTable + '/ExemptionGroundTypes'}`);


    updateModel(
        modelPartial: BuildingModel | BuildingHutsIdResponseModel | PartyModel | CodeDescriptionModel[] | SubRehababilitationModel |
            Date | Document[] | ApartmentOccupantsModel[] | JobDetailsModel | Date | Document[] | OwnerInformationModel[] |
            Document[] | Document[] | Date | Date | string | boolean,
        target: 'searchType' | 'buildingSelect' | 'isSelectRepresentative' | 'representative' | 'groundExemption' | 'subRehab' | 'ownerBuildingAcquiredDate' |
            'proofOwnership' | 'apartmentoccupant' | 'jobDetails' | 'beforeRenovationProofs' | 'afterRenovationProofs' |
            'rehabilitaionStartDate' | 'rehabilitationCompletionDate' | 'rehabilitationReason' | 'ownerInformation') {
        const model = this.subRehabilitationModelSubject.getValue();

        switch (target) {
            case 'searchType':
                model.searchType = modelPartial as string;
                break;
            case 'buildingSelect':
                model.building = modelPartial as BuildingHutsIdResponseModel;
                break;
            case 'representative':
                model.representative = modelPartial as PartyModel;
                break;
            case 'jobDetails':
                const jobDetail = modelPartial as JobDetailsModel;
                if (Array.isArray(model.jobDetails)) {
                    const indx = model.jobDetails.findIndex(x => x.jobId === jobDetail.jobId);
                    if (indx > -1) {
                        model.jobDetails[indx] = jobDetail;
                    } else {
                        model.jobDetails.push(jobDetail);
                    }
                } else {
                    model.jobDetails = [];
                    model.jobDetails.push(jobDetail);
                }
                break;
            case 'ownerInformation':
                model.ownerInformation = modelPartial as OwnerInformationModel[];
                break;
            case 'groundExemption':
                model.groundsForExemptions = modelPartial as CodeDescriptionModel[];
                break;
            case 'subRehab':
                const subRehabModel = modelPartial as SubRehababilitationModel;
                // model.rehabAmountPaymentProofs = subRehabModel.rehabAmountPaymentProofs;
                model.rehabAmount = subRehabModel.rehabAmount;
                break;
            case 'ownerBuildingAcquiredDate':
                model.ownerBuildingAcquiredDate = modelPartial as Date;
                break;
            case 'proofOwnership':
                // model.deedCopy = modelPartial as Document[];
                break;
            case 'apartmentoccupant':
                model.apartmentOccupants = modelPartial as ApartmentOccupantsModel[];
                break;
            case 'beforeRenovationProofs':
                // model.beforeRenovationProofs = modelPartial as Document[];
                break;
            case 'afterRenovationProofs':
                // model.afterRenovationProofs = modelPartial as Document[];
                break;
            case 'rehabilitaionStartDate':
                model.rehabilitaionStartDate = modelPartial as Date;
                break;
            case 'rehabilitationCompletionDate':
                model.rehabilitationCompletionDate = modelPartial as Date;
                break;
            case 'rehabilitationReason':
                model.rehabilitationReason = modelPartial as string;
                break;
            case 'isSelectRepresentative':
                model.isSelectRepresentative = modelPartial as boolean;
                break;
        }
        this.subRehabilitationModelSubject.next(model);

    }

    postGroundExemption(data: any) {
        return this.http.post(this.baseUrlJsonPayloads + `/jsonpayloads`, data);
    }

    deleteDocument(jsonDocumentId: string) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: {
                description: 'Testing'
            },
        };
        return this.http.delete(`${this.baseIncidentsAPI}/${this.transactionId}/documents/${jsonDocumentId}`, options);
    }

    uploadDocument(formData: FormData) {
        return this.http.post<JsonDocCreateResponse>(`${this.baseurl}/jsonpayloads/${this.transactionId}/documents`, formData);
    }

    documentUpload(formData: FormData) {
        return this.http.post<JsonDocCreateResponse>(`${this.baseIncidentsAPI}/${this.transactionId}/documents`, formData);
    }


    viewDocument(documentId: string) {
        return this.http.get(`${this.baseurl}/jsonpayloads/${this.transactionId}/documents/${documentId}`, { responseType: 'blob' });
    }

    postSubRehabilitation(subRehabData: RequestJsonPayload) {
        return this.http.post(`${this.baseUrlJSON}/jsonpayloads`, subRehabData);
    }

    getSubRehabilitation(transactionId): Observable<any> {
        return this.http.get(`${this.baseUrlJSON}/jsonpayloads/${transactionId}`);
    }

}
